/** Mapping to use for Radio buttons that feature Yes & No. Label is the button's visual value, and "value" is the internal value that gets set */
export const YesNoRadioOptions = [
    {
        label: 'Yes',
        value: 'yes'
    },
    {
        label: 'No',
        value: 'no'
    }
];
/** Mapping to use for Autocomplete dropdowns that feature Yes & No. Key is the dropdown option's internal value, and the key's value is the label that appears for the user */
export const YesNoAutocompleteOptions = {
    yes: 'Yes',
    no: 'No'
};
export const YesNoBooleanRadioOptions = [
    {
        label: 'Yes',
        value: true
    },
    {
        label: 'No',
        value: false
    }
];

export const borrowerContactPreferenceRadioOptions = [
    {
        label: 'Phone call',
        value: 'phone'
    },
    {
        label: 'Email',
        value: 'email'
    }
];

export const borrowerPaymentOptions = [
    {
        label: 'to my financial institution that premiums are electronically paid from',
        value: 'to my financial institution that premiums are electronically paid from'
    },
    {
        label: 'electronically to a different account',
        value: 'electronically to a different account',
        tooltip: "If you choose this option, we'll contact you after submission to confirm details."
    },
    {
        label: 'send payment via check',
        value: 'send payment via check'
    },
    {
        label: 'send to another payee',
        value: 'send to another payee',
        tooltip:
            "Payment will be sent directly to the payee to apply to your payment obligation or account. The payment is treated as if it were paid to you, the policyholder, and our company's obligation for payment is fully satisfied.\n\nIf you choose this option, we'll contact you after submission to confirm details."
    }
];
